import { useEffect, useState } from "react";
import { ChangeEvent } from "react";
import "./searchBar.scss";

type SearchBarProps = {
    modifySearchedText: (text: string) => void,
    class?: string,
};

export default function SearchBar(props: SearchBarProps) {

    const [textValue, setTextValue] = useState<string>("")

    function modifyText(event: ChangeEvent<HTMLInputElement>): void {

        const allowedCharacters = /^[a-zA-Z0-9À-ÿ\s]*$/;

        if (allowedCharacters.test(event.target.value)) {
            setTextValue(event.target.value);
        }
    }

    useEffect(() => {
        let timeoutId = setTimeout(() => {
            props.modifySearchedText(textValue);
        }, 300);

        return () => clearTimeout(timeoutId);
    });

    return (
        <div className="search-bar-container">
            <input
                type="text"
                className={"search-bar" + (props.class ? " " + props.class : "")}
                placeholder="Rechercher une espèce"
                value={textValue}
                onChange={modifyText}
            />
        </div>
    );
}
